import { urlCombiner } from "./helpers/utis";

const config = {
  development: {
    baseUrl: urlCombiner("serverBaseUrl"),
    

    api: {
      userService: urlCombiner("techappconsole.sobha.com/api/v1"),
      paymentService: "",
      normalService: "",
      cmsService: "",
      bookingService: "",
    },
  },
  staging: {
    baseUrl: "",
    api: {
      userService: "",
      paymentService: "",
      normalService: "",
      cmsService: "",
      bookingService: "",
    },
  },
  production: {
    baseUrl: "",
    api: {
      userService: "",
      paymentService: "",
      normalService: "",
      cmsService: "",
      bookingService: "",
    },
  },
};



const env = process.env.NEXT_PUBLIC_ENV_VARIABLE;

const configBasedOnEnv = config[env] ? config[env] : config.development;

export default configBasedOnEnv;
